import React from 'react';
import { FadeIn } from './FadeIn';
export function ThermalFlip() {
  return <section className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-151">
      {/* Background glow */}
      <div className="absolute inset-0 bg-amber-500/5 pointer-events-none" data-id="element-152"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/10 rounded-full blur-[150px] pointer-events-none" data-id="element-153"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-154">
        <FadeIn data-id="element-155">
          <div className="border border-amber-500/30 rounded-2xl p-8 md:p-16 bg-night-900/80 backdrop-blur-sm shadow-glow" data-id="element-156">
            <div className="text-amber-500 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-157">
              The Unique Mechanism
            </div>
            <h3 className="font-serif text-4xl md:text-5xl text-white mb-8" data-id="element-158">
              Introducing:{' '}
              <span className="text-amber-400" data-id="element-159">The Thermal Flip.</span>
            </h3>

            <div className="space-y-6 text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-160">
              <p data-id="element-161">
                This protocol doesn't focus on your mind; it focuses on your
                core body temperature.
              </p>
              <p data-id="element-162">
                By using specific "Pulse Point" cooling and the "Physiological
                Sigh," you force your heart rate to drop and your hypothalamus
                to reset in under 18 minutes.
              </p>
              <p className="font-medium text-white pt-4" data-id="element-163">
                It's a biological override that signals to your brain that the
                "emergency" is over, making deep REM sleep inevitable.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}